import Tooltip from 'bootstrap/js/src/tooltip';

const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
if (tooltipTriggerList) {
  // eslint-disable-next-line no-unused-vars,no-undef
  const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl));
}
